import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("tileWord")
  ? JSON.parse(localStorage.getItem("tileWord"))
  : {
      oneTile: "",
      twoTile: "",
      threeTile: "",
      fourTile: "",
      fiveTile: "",
      sixTile: "",
      sevenTile: "",
      eightTile: "",
      nineTile: "",
      tenTile: "",
      elevenTile: "",
      twelveTile: "",
      thirteenTile: "",
      fourteenTile: "",
      fifteenTile: "",
      sixteenTile: "",
      seventeenTile: "",
      eighteenTile: "",
      nineteenTile: "",
      twentyTile: "",
      twentyOneTile: "",
      twentyTwoTile: "",
      twentyThreeTile: "",
      twentyFourTile: "",
      twentyFiveTile: "",
      twentySixTile: "",
      twentySevenTile: "",
      twentyEightTile: "",
      twentyNineTile: "",
      thirtyTile: "",
    };

const tileWordSlice = createSlice({
  name: "tileWordSlice",
  initialState,
  reducers: {
    updateOneTile: (state, action) => {
      state.oneTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwoTile: (state, action) => {
      state.twoTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateThreeTile: (state, action) => {
      state.threeTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateFourTile: (state, action) => {
      state.fourTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateFiveTile: (state, action) => {
      state.fiveTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateSixTile: (state, action) => {
      state.sixTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateSevenTile: (state, action) => {
      state.sevenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateEightTile: (state, action) => {
      state.eightTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateNineTile: (state, action) => {
      state.nineTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTenTile: (state, action) => {
      state.tenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateElevenTile: (state, action) => {
      state.elevenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwelveTile: (state, action) => {
      state.twelveTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateThirteenTile: (state, action) => {
      state.thirteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateFourteenTile: (state, action) => {
      state.fourteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateFifteenTile: (state, action) => {
      state.fifteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateSixteenTile: (state, action) => {
      state.sixteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateSeventeenTile: (state, action) => {
      state.seventeenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateEighteenTile: (state, action) => {
      state.eighteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateNineteenTile: (state, action) => {
      state.nineteenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyTile: (state, action) => {
      state.twentyTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyOneTile: (state, action) => {
      state.twentyOneTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyTwoTile: (state, action) => {
      state.twentyTwoTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyThreeTile: (state, action) => {
      state.twentyThreeTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyFourTile: (state, action) => {
      state.twentyFourTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyFiveTile: (state, action) => {
      state.twentyFiveTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentySixTile: (state, action) => {
      state.twentySixTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentySevenTile: (state, action) => {
      state.twentySevenTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyEightTile: (state, action) => {
      state.twentyEightTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateTwentyNineTile: (state, action) => {
      state.twentyNineTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    updateThirtyTile: (state, action) => {
      state.thirtyTile = action.payload;
      localStorage.setItem("tileWord", JSON.stringify(state));
      return state;
    },
    resetTiles: (state, action) => {
      state.oneTile = "";
      state.twoTile = "";
      state.threeTile = "";
      state.fourTile = "";
      state.fiveTile = "";
      state.sixTile = "";
      state.sevenTile = "";
      state.eightTile = "";
      state.nineTile = "";
      state.tenTile = "";
      state.elevenTile = "";
      state.twelveTile = "";
      state.thirteenTile = "";
      state.fourteenTile = "";
      state.fifteenTile = "";
      state.sixteenTile = "";
      state.seventeenTile = "";
      state.eighteenTile = "";
      state.nineteenTile = "";
      state.twentyTile = "";
      state.twentyOneTile = "";
      state.twentyTwoTile = "";
      state.twentyThreeTile = "";
      state.twentyFourTile = "";
      state.twentyFiveTile = "";
      state.twentySixTile = "";
      state.twentySevenTile = "";
      state.twentyEightTile = "";
      state.twentyNineTile = "";
      state.thirtyTile = "";  
      localStorage.removeItem("tileWord");
      return state;
    },
  },
});

export const {
  updateOneTile,
  updateTwoTile,
  updateThreeTile,
  updateFourTile,
  updateFiveTile,
  updateSixTile,
  updateSevenTile,
  updateEightTile,
  updateNineTile,
  updateTenTile,
  updateElevenTile,
  updateTwelveTile,
  updateThirteenTile,
  updateFourteenTile,
  updateFifteenTile,
  updateSixteenTile,
  updateSeventeenTile,
  updateEighteenTile,
  updateNineteenTile,
  updateTwentyTile,
  updateTwentyOneTile,
  updateTwentyTwoTile,
  updateTwentyThreeTile,
  updateTwentyFourTile,
  updateTwentyFiveTile,
  updateTwentySixTile,
  updateTwentySevenTile,
  updateTwentyEightTile,
  updateTwentyNineTile,
  updateThirtyTile,
  resetTiles,
} = tileWordSlice.actions;

export default tileWordSlice;
